import type { State, Actions } from './types'
import { FETCHED } from 'store/menus/actionTypes'
import schema from './schema'

export default function (state = {} as State, action: Actions): State {
  switch (action.type) {
    case FETCHED: {
      const results = schema(action.payload)
      return results
    }
    default:
      return state
  }
}
